import { WarningIcon } from "@chakra-ui/icons";
import {
  ListIcon,
  ListItem,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Tag,
  UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import useFormCalculationWarnings from "../../hooks/useFormCalculationWarnings";

export interface CalculationErrorsProps {
  calculationErrors: string | Array<string> | undefined;
  label?: string;
}

function CalculationErrors({
  calculationErrors,
  label,
}: CalculationErrorsProps) {
  const warnings = useFormCalculationWarnings(calculationErrors ?? "");

  return (
    <Popover trigger="hover">
      <PopoverTrigger>
        <Tag colorScheme="red">
          {warnings.length} {label ? label : "Calculation Errors"}
        </Tag>
      </PopoverTrigger>
      <PopoverContent
        width="max-content"
        minWidth="300px"
        data-testid={`${label}-calcerrors`}
      >
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader>
          {warnings.length} {label ? label : "Calculation Errors"}
        </PopoverHeader>
        <PopoverBody>
          <UnorderedList listStyleType="none" margin={0}>
            {warnings.map((warning, index) => (
              <ListItem
                display="flex"
                alignItems="center"
                fontSize="sm"
                key={index}
                data-testid={`${label}-${index}-calcerrors`}
              >
                <ListIcon as={WarningIcon} color="red.500" />
                {warning}
              </ListItem>
            ))}
          </UnorderedList>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}

export default CalculationErrors;
